import React, { useState, useEffect } from "react";
import logoImg from "../assets/images/logo.png";
import iconImg from "../assets/images/icon.png";
import { Link } from "react-router-dom";
import { useSidebar } from "../context/useSidebar";

export default function NavHeader() {
  const { toggleSidebar, isSidebarOpen } = useSidebar();

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768); // Adjust the breakpoint as needed
    };

    // Initial check
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="nav-header" style={{ width: isSidebarOpen && !isSmallScreen ? "16.5rem" : "6rem" }}>
      <Link to="/" className="brand-logo" style={{ display: "flex", columnGap: 16, alignItems: "center", justifyContent: "center", background: "linear-gradient(95deg, #f69d71 0%, #f26daf 100%)" }}>
        {isSidebarOpen && !isSmallScreen ? <img src={logoImg} alt="logo" width={120} style={{ display: "block" }} /> : <img src={iconImg} alt="logo" width={isSmallScreen ? "30px" : "40px"} className="icon-img" />}
      </Link>
      <div className="nav-control" onClick={toggleSidebar}>
        <div className="hamburger">
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
          <svg width="20" height="20" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="22" y="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="22" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="11" y="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="11" y="22" width="4" height="4" rx="2" fill="#2A353A" />
            <rect width="4" height="4" rx="2" fill="#2A353A" />
            <rect y="11" width="4" height="4" rx="2" fill="#2A353A" />
            <rect x="22" y="22" width="4" height="4" rx="2" fill="#2A353A" />
            <rect y="22" width="4" height="4" rx="2" fill="#2A353A" />
          </svg>
        </div>
      </div>
    </div>
  );
}
